import { useQuery } from '@tanstack/react-query';

import { dealQueryOptions } from './query-options';

import type { TLostDealsQueryParams } from '../model/lost-deals';

export const useGetLostDealsQuery = (
    queryParams: TLostDealsQueryParams,
    { enabled = true }: { enabled?: boolean } = {}
) =>
    useQuery({
        ...dealQueryOptions.getLostDealsQueryOptions(queryParams),
        enabled,
    });
